













import Vue from 'vue';
import { mapGetters } from 'vuex';
export default Vue.extend({
  name: 'JameswayNoRouteLogo',
  inject: ['theme'],
  props: {
    height: { type: [Number, String], default: 80 }
  },
  computed: {
    ...mapGetters({
      logo: 'app/darkCompanyImage'
    })
  }
});
